module.exports = __webpack_public_path__ + "static/img/file.542eb965.svg";